import { Injectable } from '@angular/core'
import { ToastrService } from 'ngx-toastr'
import { DefaultToastComponent } from '../components/default-toast/default-toast.component'
import { IndividualConfig } from 'ngx-toastr/toastr/toastr-config'
import { HttpErrorResponse } from '@angular/common/http'

const DEFAULT_CONFIG: Partial<IndividualConfig> = {
    toastComponent: DefaultToastComponent,
    toastClass: 'ngx-toastr default-toast',
    positionClass: 'toast-top-center',
}

const DEFAULT_CONFIG_NO_TIMEOUT: Partial<IndividualConfig> = {
    ...DEFAULT_CONFIG,
    closeButton: true,
    disableTimeOut: true,
    tapToDismiss: false,
}

@Injectable({
    providedIn: 'root',
})
export class ToasterService {
    constructor(private readonly toastr: ToastrService) {}

    success(message: string, title: string): void {
        this.toastr.success(message, title, {
            ...DEFAULT_CONFIG,
            progressBar: true,
        })
    }

    info(message: string, title: string): void {
        this.toastr.info(message, title, DEFAULT_CONFIG_NO_TIMEOUT)
    }

    warning(message: string, title: string): void {
        this.toastr.warning(message, title, DEFAULT_CONFIG_NO_TIMEOUT)
    }

    error(message: string, title: string): void {
        this.toastr.error(message, title, DEFAULT_CONFIG_NO_TIMEOUT)
    }

    httpError(error: HttpErrorResponse, message?: string | undefined, timeOut = false): void {
        let title = 'Unknown error occurred'
        let altMessage = error.statusText
        switch (error.status) {
            case 400:
                title = 'Invalid request'
                break
            case 401:
                title = 'Authentication error'
                altMessage = 'Something went wrong with the login session.'
                break
            case 403:
                title = 'Authorization error'
                altMessage = 'You seem to not be authorized to access this resource.'
                break
            case 404:
                title = 'Resource not found'
                altMessage = 'The requested resource does not exist.'
                break
            case 409:
                title = 'Resource already exists'
                altMessage = ''
                break
        }
        // Prefer API body message ({ message } or plain string) over statusText / defaults.
        altMessage = extractHttpErrorBodyMessage(error.error) ?? altMessage

        this.toastr.error(
            `${message ? `${message} ${altMessage}` : altMessage}`.trim(),
            title,
            timeOut ? DEFAULT_CONFIG : DEFAULT_CONFIG_NO_TIMEOUT
        )
    }
}

function extractHttpErrorBodyMessage(errorBody: unknown): string | undefined {
    if (typeof errorBody === 'string' && errorBody.trim()) {
        return errorBody
    }
    if (errorBody && typeof errorBody === 'object') {
        const message = (errorBody as { message?: unknown }).message
        if (typeof message === 'string' && message.trim()) {
            return message
        }
    }
    return undefined
}
